import type { App, Ref } from "vue";

// 自定义指令：自动设置元素宽度
const vAutoWidth = {
  mounted: (el: HTMLElement, binding: any, vnode: any) => {
    // 等待下一帧确保元素已渲染
    requestAnimationFrame(() => {
      // 通过vnode.ctx访问组件实例提供的isMobile值
      const isMobile = vnode.ctx?.provides?.isMobile as Ref<boolean> | undefined;

      if (isMobile?.value) {
        el.style.width = "100%";
        return;
      }

      // 创建一个临时的元素来测量自然宽度
      const tempEl = el.cloneNode(true) as HTMLElement;
      tempEl.style.position = "absolute";
      tempEl.style.visibility = "hidden";
      tempEl.style.width = "auto";
      tempEl.style.minWidth = "0";
      tempEl.style.maxWidth = "none";

      // 添加到DOM中进行测量
      document.body.appendChild(tempEl);

      // 获取自然宽度并应用到原元素
      const naturalWidth = tempEl.offsetWidth;
      el.style.width = `${Math.max(naturalWidth + 2, 120)}px`;

      // 清理临时元素
      document.body.removeChild(tempEl);
    });
  },
};

export default {
  install: (app: App) => {
    app.directive("auto-width", vAutoWidth);
  },
};

export { vAutoWidth };
